export default "__VITE_ASSET__DHGPUUuo__"